import styled from 'styled-components';
import {BGImageCenter} from '../../../../../globalVariables/GlobalVariables';
import {
    dFlex,
    dFlexColumn,
    dFlexCenter,
    dFlexBetween,
    alignCenter,
    justifyEnd,
} from '../../../../../globalVariables/GlobalFlex';

export const wrap = styled.div`
    ${dFlexColumn};
    gap: var(--space-sm);
    width: 100%;
`;

export const header = styled.header`
    ${dFlexColumn};
    gap: var(--space-xs);
    width: 100%;
    text-align: start;
`;

export const headerTitle = styled.h3`
    margin: 0;
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
`;

export const headerSubtitle = styled.p`
    margin: 0;
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-caption);
    line-height: var(--line-height-caption);
    color: var(--TA-color-text-default);
`;

export const list = styled.div`
    ${dFlexColumn};
    gap: var(--space-sm);
    width: 100%;
`;

export const card = styled.div<{$checked: boolean}>`
    box-sizing: border-box;
    ${dFlexBetween};
    width: 100%;
    height: 44px;
    background: var(--TA-color-bg-base);
    border: ${({$checked}) => $checked
    ? '2px solid var(--TA-color-border-brand)'
    : '1px solid var(--TA-color-border-disabled)'};
    border-radius: var(--radius-xs);
    overflow: hidden;
`;

export const cardInfo = styled.div`
    ${dFlex}
    ${alignCenter}
    flex: 1 0 0;
    min-width: 0;
    height: 100%;
    gap: var(--space-lg);
    padding-inline-start: var(--space-sm);
    padding-inline-end: var(--space-lg);
`;

export const price = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyEnd}
    flex: 1 0 0;
    min-width: 0;
    height: 100%;
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-body-small);
    line-height: var(--line-height-caption);
    color: var(--TA-color-text-default);
    white-space: nowrap;
`;

export const titleGroup = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-lg);
    flex-shrink: 0;
`;

export const title = styled.span`
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
    white-space: nowrap;
`;

export const sticker = styled.div<{$color: string; $icon?: string; $image?: string}>`
    flex-shrink: 0;
    width: 44px;
    align-self: stretch;
    background-color: ${({$color}) => $color};
    ${({$icon, $image}) => $image
    ? BGImageCenter($image, 'cover')
    : $icon ? BGImageCenter($icon, '24px') : ''}
    background-position: center;
`;

export const addBtnWrap = styled.div`
    ${dFlexCenter};
    width: 100%;
    padding-top: var(--space-sm);
`;

export const empty = styled.div`
    padding: var(--space-xl) 0;
    text-align: center;
    color: var(--TA-color-text-subtle);
    font-size: var(--font-size-body-small);
`;
